export const CARD_TYPES = {
    UTILIZATION: 'utilization',
    DETAILS: 'details',
    TOP_TEN_OPPORTUNITIES: 'topTenOpportunities',
    PROJECT_DETAILS: 'projectDetails',
    STAT: 'stat',
    MIGRATION_STATUS: 'migrationStatus',
    LANDING_ZONES: 'landingZones',
};
